import React from 'react';

interface IProps {
  color?: string;
}

function PinwheelLogo({ color }: IProps): JSX.Element {
  return (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.02093 4.97605C3.23875 4.18798 2.06525 4.25373 1.34782 5.23859C-0.674501 8.58671 -0.347452 13.1813 2.52085 16.0701C5.39057 18.9584 9.82465 19.4835 13.2799 17.2517C14.193 16.5947 14.3239 15.3478 13.5418 14.5602C11.3238 12.3937 6.43316 7.4046 4.02093 4.97605Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.7778 4.05689C27.5605 3.26882 27.4957 2.08766 26.5174 1.36534C23.1912 -0.66965 18.6271 -0.341365 15.7583 2.54697C12.8896 5.43531 12.3673 9.9646 14.5196 13.4442C15.1709 14.3629 16.4105 14.4944 17.1932 13.7068C19.3445 11.606 24.4308 6.48592 26.7778 4.05689Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.99914 27.9526C4.21696 28.7407 4.28076 29.9223 5.25955 30.6442C8.58534 32.6792 13.1503 32.3509 16.0191 29.463C18.8888 26.5747 19.4101 22.1107 17.1931 18.6315C16.5414 17.7124 15.3026 17.5809 14.5195 18.369C12.432 20.4693 7.41184 25.5241 4.99914 27.9526Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.6267 26.9016C28.4079 27.6887 29.5828 27.6235 30.2993 26.6391C32.3216 23.2909 31.995 18.6954 29.1258 15.8076C26.1913 12.8535 21.8229 12.3937 18.3667 14.6259C17.4541 15.282 17.2579 16.4637 18.1049 17.317C21.2791 20.5116 24.453 23.7064 27.6267 26.9016Z"
        fill={color}
      />
    </>
  );
}

PinwheelLogo.prototype.svgPropOverrides = { viewBox: '0 0 32 32' };

export default PinwheelLogo;
